var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceMessagingcomponent = function SvgWorkspaceMessagingcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3 6h21a3 3 0 0 1 3 3v18c0 1.65-1.35 3-3 3h-21a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3Zm0 21h21V12h-21v15Z",
    fill: "#FAD156"
  })));
};
export default SvgWorkspaceMessagingcomponent;